import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { StatCard } from '../../models/dashboard.model';

@Component({
  selector: 'app-stats-grid',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './stats-grid.component.html',
  styleUrl: './stats-grid.component.scss',
})
export class StatsGridComponent {
  @Input({ required: true }) cards: StatCard[] = [];
  @Input() columns = 3;

  trackByTitle(_: number, item: StatCard): string {
    return item.title;
  }

  getChangeClass(type: StatCard['changeType']): string {
    if (type === 'positive') return 'positive';
    if (type === 'negative') return 'negative';
    if (type === 'warning') return 'warning';
    return 'neutral';
  }
}

